<template>
    <div v-if="player" class="size-7 player-general">
        <!-- fields -->
        <!-- if locked -->
        <div v-if="player.isLocked" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label player-is-locked">Locked until</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.lockoutEndDate | datetime}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div v-if="player.lockReason" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label player-is-locked">Lock reason</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.lockReason}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal"></div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <a v-if="player.isLocked" class="button" @click="unlockPlayer()">Unlock</a>
                        <a v-else class="button is-warning" @click="lockPlayer()">Lock</a>
                    </p>
                </div>
            </div>
        </div>
        <!-- username -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Login</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text" :O_O="player.uPwd">{{player.username}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- registered -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Registered</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.registered | datetime}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- registration type -->
        <div
            v-if="player.registrationInfo && player.registrationInfo.type"
            class="field is-horizontal"
        >
            <div class="field-label is-normal">
                <label class="label">Registration type</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.registrationInfo.type}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- alias -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Alias</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.alias}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- email -->
        <div v-if="player.email" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Email</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.email}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- phone number -->
        <div v-if="player.phoneNumber" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Phone number</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.phoneNumber}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- messenger -->
        <div v-if="player.phoneNumber" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Messenger</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.messenger}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- first middle last name -->
        <div
            v-if="player.firstName || player.middleName || player.lastName"
            class="field is-horizontal"
        >
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span
                            class="oc-form-text"
                        >{{player.firstName}} {{player.middleName}} {{player.lastName}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- date of birth -->
        <div v-if="player.dateOfBirth" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Date of birth</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.dateOfBirth | date}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- passport -->
        <div v-if="player.passport" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Passport</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.passport}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- post address -->
        <div v-if="player.address" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Post address</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.address}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- IP -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">IP</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span
                            class="oc-form-text"
                        >registration {{player.registrationInfo && player.registrationInfo.ip}}, last {{player.lastIp}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- UserAgent -->
        <div
            v-if="player.registrationInfo && player.registrationInfo.userAgent"
            class="field is-horizontal"
        >
            <div class="field-label is-normal">
                <label class="label">UserAgent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.registrationInfo.userAgent}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- FastLoginKey -->
        <div v-if="player.fastLoginKey" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Fast login key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{player.fastLoginKey}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- RtpLevel -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">RTP level</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select" :class="{'is-danger': player.rtpLevel == 'veryGreedy', 'is-warning': (['slightlyGreedy', 'littleGreedy', 'greedy'].includes(player.rtpLevel))}">
                            <select v-model="player.rtpLevel">
                                <option :value="null">default/inherited</option>
                                <option>normal</option>
                                <option>littleGreedy</option>
                                <option>slightlyGreedy</option>
                                <option>greedy</option>
                                <option>veryGreedy</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- freeze profile -->
        <div class="field is-horizontal">
            <div class="field-label">
                <label v-if="player.isProfileFrozen" class="label has-text-warning">Profile is frozen</label>
                <label v-else class="label">Profile is <span style="text-decoration:underline;">editable</span></label>
            </div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div v-if="player.isProfileFrozen" class="control">
                        <button @click="player.isProfileFrozen = false; save();" class="button is-warning">Unfreeze profile</button>
                    </div>
                    <div v-else class="control">
                        <button @click="player.isProfileFrozen = true; save();" class="button">Freeze profile</button>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- change password -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Change password</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="passwordReset.oldPassword" class="input" type="text" placeholder="Old password">
                    </p>
                </div>
                <div class="field">
                    <p class="control">
                        <input v-model="passwordReset.newPassword" class="input" type="text" placeholder="New password">
                    </p>
                </div>
                <div class="field">
                    <p class="control">
                        <button @click="changePassword()" class="button">Change</button>
                    </p>
                </div>
            </div>
        </div>

        <!-- reset password -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Reset password</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <button @click="resetPassword()" class="button is-danger">Reset</button>
                    </p>
                </div>
            </div>
        </div>

        <!-- balances -->
        <p class="title is-5">Balances</p>
        <div class="field">
            <div class="control">
                <router-link
                    class="button is-success"
                    :to="{'name':'create-balance'}"
                >Create balance</router-link>
            </div>
        </div>
        <table class="table is-fullwidth is-hoverable">
            <tr>
                <th>ID</th>
                <th>Num</th>
                <th>Branch</th>
                <th>Balance</th>
                <th>Bonus</th>
                <th>Demo</th>
            </tr>
            <tr v-for="balance in player.balances" :key="balance.number">
                <td>
                    {{balance.id}}
                    <span v-if="balance.isActive" class="tag is-success">active</span>
                </td>
                <td>{{balance.number}}</td>
                <td>
                    <description :obj="balance" />
                </td>
                <td>{{balance.real | currency(balance.currency)}}</td>
                <td>{{balance.bonus | currency(balance.currency)}}</td>
                <td>
                    <span
                        class="tag button-tag"
                        :class="{'is-light':!balance.isDemo}"
                        @click="balance.isDemo = false; saveBalance(balance);"
                    >real</span>
                    <span
                        class="tag button-tag"
                        :class="{'is-danger':balance.isDemo}"
                        @click="balance.isDemo = true; saveBalance(balance);"
                    >demo</span>
                </td>
            </tr>
        </table>

        <!-- bonuses -->
        <p class="title is-5">Bonuses</p>
        <div class="is-size-7">
            <template v-for="balance in player.balances">
                <p
                    :key="balance.id"
                    class="title is-6"
                >Balance #{{balance.number}}, branch '{{balance.branch}}', {{balance.currency}}</p>
                <template v-for="bonus in balance.bonuses">
                    <template v-if="bonus.bonusType == 'cashback' || bonus.bonusType == 'cashback-single'">
                        <table :key="`${bonus.id}_cashback`" class="table is-fullwidth is-hoverable bonuses-table">
                            <tr>
                                <th class="narrow-column">ID</th>
                                <th class="narrow-column">Type</th>
                                <th class="narrow-column">Created</th>
                                <th class="narrow-column">Payment date</th>
                                <th>Estimated payment</th>
                                <th class="narrow-column">Completed</th>
                                <th class="narrow-column">Reason</th>
                            </tr>
                            <tr>
                                <td>{{bonus.id}}</td>
                                <td>{{bonus.bonusType}}</td>
                                <td>{{bonus.createdAt | datetime}}</td>
                                <td>{{bonus.payTime | datetime}}</td>
                                <td>{{bonus.estimatedAmount | currency(balance.currency)}}</td>
                                <td>
                                    <template
                                        v-if="bonus.completedAt"
                                    >{{bonus.completedAt | datetime}}</template>
                                    <template v-else>
                                        <span class="tag is-light">active</span>
                                    </template>
                                </td>
                                <td>{{bonus.completeReason}}</td>
                            </tr>
                        </table>
                    </template>
                    <template v-else>
                        <table :key="`${bonus.id}_playthrough`" class="table is-fullwidth is-hoverable bonuses-table">
                            <tr>
                                <th class="narrow-column">ID</th>
                                <th class="narrow-column">Type</th>
                                <th class="narrow-column">Created</th>
                                <th class="narrow-column">Progress%</th>
                                <th>Start bonus amount</th>
                                <th>Current bonus amount</th>
                                <th>Progress</th>
                                <th class="narrow-column">Completed</th>
                                <th class="narrow-column">Reason</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>{{bonus.id}}</td>
                                <td>{{bonus.bonusType}}</td>
                                <td>{{bonus.createdAt | datetime}}</td>
                                <td>{{bonus.betProgressPercent | tofixed(2)}}%</td>
                                <td>{{bonus.startAmount | currency(balance.currency)}}</td>
                                <td>{{bonus.currentAmount | currency(balance.currency)}}</td>
                                <td>{{bonus.betProgress | currency(balance.currency)}}</td>
                                <td>
                                    <template
                                        v-if="bonus.completedAt"
                                    >{{bonus.completedAt | datetime}}</template>
                                    <template v-else>
                                        <span class="tag is-success">active</span>
                                    </template>
                                </td>
                                <td>{{bonus.completeReason}}</td>
                                <td>
                                    <a v-if="!bonus.completedAt" @click="dropBonus(balance, bonus)" class="button is-small">DROP</a>
                                </td>
                            </tr>
                        </table>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import playerService from '../../../../../services/player.service';
import balanceService from '../../../../../services/balance.service';
import bonusService from '../../../../../services/bonus.service';

import description from '../../../../common/description.vue';

export default {
    name: 'player-general',
    components: { description },
    data() {
        return {
            player: null,
            passwordReset: {
                oldPassword: '',
                newPassword: ''
            }
        };
    },
    computed: {
        playerId() {
            return this.$route.params.playerId;
        }
    },
    async mounted() {
        await this.load();
    },
    methods: {
        async load() {
            await playerService.load(this.playerId);
            let player = utils.clone(state.editPlayer.get());
            if (player.balances.length) {
                for (var i = 0; i < player.balances.length; i++) {
                    player.balances[i].bonuses = await bonusService.getBalanceBonuses(player.balances[i].id);
                }
            }
            this.player = player;
        },
        async save() {
            await playerService.save(this.player);
            await this.load();
        },
        async saveBalance(balance) {
            await balanceService.save(balance);
            await this.load();
        },
        async lockPlayer() {
            if (confirm('Are you sure you want to lock player ' + this.player.username + '?')) {
                await playerService.lock(this.player.id);
                await this.load();
            }
        },
        async unlockPlayer() {
            if (confirm('Are you sure you want to unlock player ' + this.player.username + '?')) {
                await playerService.unlock(this.player.id);
                await this.load();
            }
        },
        async dropBonus(balance, bonus) {
            if (confirm('Are you sure you want to drop bonus ' + bonus.id + '?')) {
                await bonusService.drop(balance.id, bonus.id);
                await this.load();
            }
        },
        async changePassword() {
            if (this.passwordReset.oldPassword && this.passwordReset.newPassword) {
                await playerService.changePassword(this.player.id, this.passwordReset.oldPassword, this.passwordReset.newPassword);
                this.passwordReset.oldPassword = '';
                this.passwordReset.newPassword = '';
                await this.load();
            }
        },
        async resetPassword() {
            if (confirm(`Are you sure you want to reset password for player ${this.player.username}?`)) {
                await playerService.resetPassword(this.player.id);
                await this.load();
            }
        }
    }
};
</script>
<style lang="scss">
.player-general {
    .player-is-locked {
        color: red !important;
        font-weight: bold !important;
    }
    .bonuses-table {
        .narrow-column {
            width: 180px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/general.vue